/* eslint-disable camelcase */
import { TealiumPayload } from '@types'

export type LoggedInState = 'true' | 'false' | undefined
export interface ClickEventOptions {
  /**
   *  BLAST DATA
   */
  event_category: 'Medicare Complaint Form';
  event_action: string;
  event_label: string;
  event_name: string;
  page: string;
  text?: string;
  /**
   *  heading is the name of the form section that the input lies under ex: Preferred Callback Time
   */
  header?: string;
  subheading?: string;
   /**
   *  'ui interaction' || "conversion"  //conversion for step7 since
   *  ui interaction unless the user is hitting submit which is a conversion?
   */
  event_type: 'ui interaction' | 'conversion';
  component: 'Medicare Complaint Form'; // always for mcf
  target_location?: string; // only for 5b where there is an anchor/button that directs to a new page, other buttons like next/back do not have this

  // on error, send these
  error_message?: string;
  error_code?: string;
  error_type?: string;

  // mcf only
  step_number?: string;

  // if possible, lets only send these when they exist
  // submit step only
  preferred_language?: string;
  access_complaint?: string;
  prefer_call_back_time?: string;

  logged_in?: LoggedInState; // getUserLoggedInState

  /**
   *  TODO: CORE DATA BELOW
   */

}

export const sendTealiumClickEvent = async (options: ClickEventOptions): Promise<string> => {
  if (!window.utag) return ''
  const payload: TealiumPayload = {
    page: options.page,
    ...options.logged_in ? { logged_in: options.logged_in } : {},
    ...options.event_category ? { event_category: options.event_category } : { event_category: 'Medicare Complaint Form' },
    event_action: options.event_action,
    event_label: options.event_label,
    ...options.event_name ? { event_name: options.event_name } : {},
    ...options.text ? { text: options.text } : {},
    ...options.header ? { header: options.header } : {},
    event_type: options.event_type,
    ...options.component ? { component: options.component } : { component: 'Medicare Complaint Form' },
    ...options.target_location ? { target_location: options.target_location } : {},
    ...options.error_message ? { error_message: options.error_message } : {},
    ...options.error_code ? { error_code: options.error_code } : {},
    ...options.error_type ? { error_type: options.error_type } : {},
    ...options.step_number ? { step_number: options.step_number } : {},
    ...options.preferred_language ? { preferred_language: options.preferred_language } : {},
    ...options.access_complaint ? { access_complaint: options.access_complaint } : {},
    ...options.prefer_call_back_time ? { prefer_call_back_time: options.prefer_call_back_time } : {}
  }

  window.utag.link(payload)

  return `Tealium event sent: ${payload.event_category} - ${payload.component} - ${payload.event_action} - ${payload.event_label}`
}
